import React from "react";
import "./../WithoutRunningAds/RunningAds.css";

function RunningAds() {
  return (
    <div className="main_div_running_ads">
      <p className="heading_running_ads">
        Find your next deal right now. Buy PPC leads without running ads.
      </p>
      <p className="para_running_ads">
        Find out seller’s motivation, repairs needed and more BEFORE you commit
        to buying the lead. All leads are guaranteed to be off market.
      </p>
      <div className="white_div_running_ads mt-5">
        <p className="para_white_div_running_ads mx-3">
          <li>
            At PPC Leads to Leads you can preview the city, state, seller’s
            reason for selling and the repairs needed BEFORE you ever commit to
            buying the lead
          </li>
        </p>
      </div>
      <div className="white_div_running_ads mt-3">
        <p className="para_white_div_running_ads mx-3">
          <li>
            You’ll find fresh, live PPC seller leads in every city and state,
            including yours.
          </li>
        </p>
      </div>
      <div className="white_div_running_ads mt-3">
        <p className="para_white_div_running_ads mx-3">
          <li>
            We ONLY generate motivated sellers, no tire kickers and “what’s my
            home worth” leads.
          </li>
        </p>
      </div>
      <div className="white_div_running_ads mt-3">
        <p className="para_white_div_running_ads mx-3">
          <li>
            We guarantee that every lead is off market. If it’s listed or
            already under contract it’s your money back.
          </li>
        </p>
      </div>
    </div>
  );
}

export default RunningAds;
